import { Injectable } from '@angular/core';
import { StateService, UrlService } from '@uirouter/core';

@Injectable({
    providedIn: 'root'
})
export class GlobalNav {
    private state: StateService;
    private route: UrlService;

    constructor(route: UrlService, state: StateService) {
        Object.assign(this, { route, state });
    }

    public stateActive(navMenuItems: CmsNavMenuItems): boolean {
        return navMenuItems.pathMatch ? Boolean(this.route.url().match(navMenuItems.pathMatch)) : Boolean(navMenuItems.uiSref === this.state.current.name);
    }
}
